export default __webpack_public_path__ + "static/media/AccessibleProgramming_Cecily_Paper_2018.34927a8a.pdf";